import {ModuleWithProviders, NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TorchAPIConfiguration, TorchAPIConfigurationParams} from '../../config/api.configuration';
import {LoggingService} from '../../../app/shared/services/logging.service';

@NgModule({
  imports: [
    CommonModule,
  ],
})
export class TorchDocumentationModule {
  constructor(@Optional() @SkipSelf() parentModule: TorchDocumentationModule, private logger: LoggingService) {
    if (parentModule) {
      throw new Error('TorchDocumentationModule is already loaded. Import in your base TorchBackend only.');
    }

    logger.log('Loaded TorchDocumentationModule');
  }

  static forRoot(params: TorchAPIConfigurationParams): ModuleWithProviders<unknown> {
    return {
      ngModule: TorchDocumentationModule,
      providers: [
        {
          provide: TorchAPIConfiguration,
          useValue: params
        },
      ]
    };
  }
}
